var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingBishopVectorStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Game_Layer",
    "data-name": "Game Layer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b8fb3;\n      }\n\n      .cls-2 {\n        fill: #43363f;\n      }\n\n      .cls-3 {\n        fill: #0fc3f4;\n      }\n\n      .cls-4 {\n        fill: #1c1118;\n      }\n\n      .cls-5 {\n        fill: #0b90b4;\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-7 {\n        fill: #574652;\n      }\n\n      .cls-8 {\n        fill: #1b1017;\n      }\n\n      .cls-9 {\n        fill: #241620;\n      }\n\n      .cls-10 {\n        fill: #0c95ba;\n      }\n\n      .cls-11 {\n        fill: #0b91b5;\n      }\n\n      .cls-12 {\n        fill: #0c96bb;\n      }\n\n      .cls-13 {\n        fill: #0c93b7;\n      }\n\n      .cls-14 {\n        fill: #40333c;\n      }\n\n      .cls-15 {\n        fill: #0b92b7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "313.69 456.2 142.68 456.2 414.16 242.63 585.17 242.63 313.69 456.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "585.17 242.63 862.16 456.2 960.75 1269.87 866.78 1800 303.56 1800 209.59 1269.87 313.69 456.2 585.17 242.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "303.56 1800 132.55 1800 38.58 1269.87 209.59 1269.87 303.56 1800"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "209.59 1269.87 38.58 1269.87 142.68 456.2 313.69 456.2 209.59 1269.87"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "790.08 1004.55 764.43 1004.55 740.18 926.93 765.83 926.93 790.08 1004.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "765.83 926.93 740.18 926.93 669.87 886.43 695.53 886.43 765.83 926.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "830.95 1035.24 805.3 1035.24 669.01 1033.13 694.66 1033.13 830.95 1035.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "643.52 1053.54 617.87 1053.54 653.81 1002.84 679.47 1002.84 643.52 1053.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "641.75 1053.54 616.1 1053.54 617.87 1053.54 643.52 1053.54 641.75 1053.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "695.53 886.43 669.87 886.43 616.1 744.09 641.75 744.09 695.53 886.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 562.37,
    y: 742.39,
    width: 25.65,
    height: 311.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "585.78 1053.54 560.13 1053.54 562.37 1053.54 588.03 1053.54 585.78 1053.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "583.22 675.01 557.57 675.01 589.97 633.97 615.62 633.97 583.22 675.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "571.17 1083.59 545.52 1083.59 506.6 1033.1 532.25 1033.1 571.17 1083.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "505.57 865.58 479.92 865.58 557.57 675.01 583.22 675.01 505.57 865.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "434.93 1004.55 409.28 1004.55 521.04 1002.82 546.7 1002.82 434.93 1004.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "434.21 906.69 408.55 906.69 479.92 865.58 505.57 865.58 434.21 906.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M790.81,906.69l40.15,128.55-136.29-2.11-35.77,50.46h-87.72s-38.92-50.49-38.92-50.49l-138.2,2.13,40.15-128.55,71.36-41.11,77.65-190.57,32.4-41.04,32.2,41.63,71.81,190.08,71.18,41ZM588.03,1053.54v-311.15l-58.74,144.14-70.12,40.39-24.24,77.62,111.76-1.73,39.09,50.72h2.24M679.47,1002.84l110.61,1.71-24.25-77.62-70.3-40.5-53.77-142.34v309.46h1.77s35.94-50.71,35.94-50.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "394.05 1035.24 368.4 1035.24 408.55 906.69 434.21 906.69 394.05 1035.24"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "962.08 1269.62 935.77 1416.83 240.91 1416.83 214.6 1269.62 962.08 1269.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "240.91 1416.83 235.78 1416.83 209.47 1269.62 214.6 1269.62 240.91 1416.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "214.6 1269.62 209.47 1269.62 956.95 1269.62 962.08 1269.62 214.6 1269.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBishopVectorStation);
export default __webpack_public_path__ + "static/media/building-bishop-vector-station.92fdec110c1c59f4a4c99bdf62ca3f3d.svg";
export { ForwardRef as ReactComponent };